export default __webpack_public_path__ + "static/media/YAS0790.34I-35658_-20747_0.d0c91ae4.jpg";